module.exports = __webpack_public_path__ + "img/img_qian@2x.15517ca3.png";